module.exports = __webpack_public_path__ + "img/logo.b413252e.png";